var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_5140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.24292 0 0 2.24292 0 5C0 7.75708 2.24292 10 5 10C7.75708 10 10 7.75708 10 5C10 2.24292 7.75708 0 5 0ZM4.96208 6.42458C4.80083 6.58583 4.58875 6.66625 4.37583 6.66625C4.16292 6.66625 3.94875 6.585 3.78583 6.4225L2.62667 5.29917L3.20708 4.70042L4.37083 5.82833L6.79125 3.45292L7.37625 4.04667L4.96208 6.42458Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_5140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.892c29a4ff1a6e0b36a8db3cbdefdb1d.svg";
export { ForwardRef as ReactComponent };